exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-message[data-v-2e822a96] {\n  font-size: 0.66666667rem;\n  line-height: 2.25;\n  color: #cf4931;\n  line-height: 1.4;\n  display: inline-block;\n}\n", ""]);

// exports
